import React,{useState,useEffect} from 'react'
import TextField from '../../components/TextField'
import SubmitButton from '../../components/SubmitButton'
import {Error, Success} from '../../components/Status'
import {useCreateFormCategory} from '../../hooks/formCategories/useCreate'

const CreateFormCategory = () => {
    // STATES
    // PAYLOAD STATE
    const [state,setState]=useState({
        categoryName:"",
        description:""
    })
    // MISC STATE
    const [error,setError]=useState("")
    const [success,setSuccess]=useState("")

    // MUTATION
    const {mutate:createFormCategory,error:createError,isLoading,isSuccess}=useCreateFormCategory(state)
    
    // HANDLERS
    // INPUT HANDLER
    const handleChange=({target:{name,value}})=>{
            setState({...state,[name]:value})
    }

    // SUBMIT HANDLER
    const handleSubmit=(e)=>{
        e.preventDefault();
        // REFRESH ERROR
        setError('')
        createFormCategory()
    }

    // EFFECTS
    useEffect(()=>{
        if(isSuccess){
            setSuccess("Form Category created successfully")
            setTimeout(() => {
                window.location.reload()
            }, 2000);
        }
    },[isSuccess])

    useEffect(()=>{
        if(createError){
            const message=createError?.response?.data?.message
            setError(message)
        }
    },[createError])

    return (
        <form className='w-full flex flex-col space-y-5' onSubmit={handleSubmit}>
            {success.length>0&&<Success>{success}</Success>}
            {error.length>0&&<Error>{error}</Error>}
            <TextField label='Name' required name='categoryName' value={state.categoryName} onChange={handleChange} />
            <TextField label='Description' type='textarea' name='description' value={state.description} onChange={handleChange} />
            <SubmitButton loading={isLoading}>Submit</SubmitButton>
        </form>
    )
}

export default CreateFormCategory
